import { useEffect, useState } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { useIntl } from "react-intl";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import InboxDetailModal from "../../../common/components/InboxDetailModal";
import { fetchLoginPage } from "../api/loginapi";
import { LoginTab } from "../enum/LoginTab";
import { ForgetPasswordTab } from "./loginTab/ForgotPasswordTab";
import { GoogleRegisterTab } from "./loginTab/GoogleRegisterTab";
import { LoginChooseTab } from "./loginTab/LoginChoose";
import { LoginFormTab } from "./loginTab/LoginFormTab";
import { LoginPhoneAuthTab } from "./loginTab/LoginPhoneAuthTab";
import { RegisterMethodTab } from "./loginTab/RegisterMethodTab";
import { RegisterTab } from "./loginTab/RegisterTab";

export const LoginRegisterDialog = ({ initialTab }) => {
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const platform = sessionStorage.getItem("platform");
  const [showRegisterFgtPassword, setShowRegisterFgtPassword] = useState();
  const [showModal, setShowModal] = useState(false);
  const [selectedInbox, setSelectedInbox] = useState(null);
  const [swalProps, setSwalProps] = useState({});
  const [loginTab, setLoginTab] = useState(
    initialTab
      ? initialTab
      : platform === "telegram"
        ? LoginTab.LOGIN_CHOOSE
        : LoginTab.LOGIN
  );
  const [tempAuth, setTempAuth] = useState();
  const { credential } = useParams();
  const params = new URLSearchParams(window.location.search);
  const isNeedAutoLogin = params.get("telegramid") && params.get("accesscode");

  const handleInboxClick = (inbox) => {
    setSelectedInbox(inbox);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };


  const registerTab = loginTab === LoginTab.REGISTER_PART_1 || loginTab === LoginTab.REGISTER_PART_2 || loginTab === LoginTab.REGISTER_PART_3


  useEffect(() => {
    document.body.classList.add(
      "pages-bg",
      "h-100",
      "scroll-y-default",
      "bg-dark"
    );
    document.querySelector("html").classList.add("h-100", "scroll-y-default");
    document
      .querySelector("#root")
      .classList.add("h-100", "w-100", "scroll-y-default", "position-absolute");

    document.body.style.backgroundImage = `url(${process.env.PUBLIC_URL}/image/loginbackground.webp)`;

    return () => {
      document.body.style.backgroundImage = ``;
      document.body.classList.remove(
        "pages-bg",
        "h-100",
        "scroll-y-default",
        "bg-dark"
      );
      document
        .querySelector("html")
        .classList.remove("h-100", "scroll-y-default");
      document
        .querySelector("#root")
        .classList.remove(
          "h-100",
          "w-100",
          "scroll-y-default",
          "position-absolute"
        );
    };
  }, []);

  useEffect(() => {
    fetchLoginPage(location.state?.companyCode).then((res) =>
      setShowRegisterFgtPassword(res)
    );
  }, []);

  const handleBack = () => {
    if (loginTab === LoginTab.LOGIN) {
      navigate("/");
    }
    if (loginTab === LoginTab.REGISTER_PART_1) {
      navigate("/login");
    }
    const backTab =
      loginTab === LoginTab.REGISTER_PART_1 ||
        loginTab === LoginTab.GOOGLE_REGISTER
        ? LoginTab.LOGIN
        : loginTab === LoginTab.REGISTER_PART_2
          ? LoginTab.REGISTER_PART_1
          : loginTab === LoginTab.FORGOT_PASSWORD_PART_2
            ? LoginTab.FORGOT_PASSWORD_PART_1
            : loginTab === LoginTab.LOGIN_PHONE_AUTH_STEP_2
              ? LoginTab.LOGIN_PHONE_AUTH_STEP_1
              : platform === "telegram"
                ? LoginTab.LOGIN_CHOOSE
                : LoginTab.LOGIN;

    if (
      loginTab === LoginTab.REGISTER_PART_2 ||
      loginTab === LoginTab.FORGOT_PASSWORD_PART_2 ||
      loginTab === LoginTab.LOGIN_PHONE_AUTH_STEP_2
    ) {
      setSwalProps({
        show: true,
        icon: "info",
        title: intl.formatMessage({ id: "alert" }),
        text: intl.formatMessage({
          id: "backErrorDescription",
        }),
        showCancelButton: true,
        showConfirmButton: true,
        confirmButtonText: intl.formatMessage({ id: "confirm" }),
        denyButtonText: intl.formatMessage({ id: "cancel" }),
        onConfirm: () => {
          setLoginTab(
            loginTab === LoginTab.REGISTER_PART_2
              ? LoginTab.REGISTER_PART_1
              : platform === "telegram"
                ? LoginTab.LOGIN_CHOOSE
                : LoginTab.LOGIN
          );
        },
      });
    } else {
      setLoginTab(backTab);
    }
  };

  return (
    <div
      className={`d-flex flex-column justify-content-center align-item-stretch mx-auto w-100 ${loginTab === LoginTab.LOGIN || registerTab ?
        "" : "h-100"
        }`}
      style={{ maxWidth: "700px" }}
    >
      <InboxDetailModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        selectedInbox={selectedInbox}
      />
      <SweetAlert2
        heightAuto={false}
        {...swalProps}
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
      />
      <div>
        {(loginTab !== LoginTab.LOGIN && loginTab !== LoginTab.LOGIN_CHOOSE) ||
          (!isNeedAutoLogin && (
            <div style={{ marginLeft: "20px", marginTop: "20px" }}>
              <button
                onClick={handleBack}
                style={{ background: "none", border: "none" }}
              >
                <FiArrowLeft size={25} style={{ color: "white" }} />
              </button>
            </div>
          ))}
      </div>
      <div className="d-flex justify-content-center flex-column">
        <div
          className={
            loginTab === LoginTab.LOGIN_CHOOSE || loginTab === LoginTab.LOGIN || registerTab
              ? "w-100"
              : "col-10"
          }
        >
          {loginTab === LoginTab.LOGIN_CHOOSE ? (
            <LoginChooseTab
              setSwalProps={setSwalProps}
              setLoginTab={setLoginTab}
              setTempAuth={setTempAuth}
              credential={credential}
            />
          ) : loginTab === LoginTab.LOGIN ? (
            <LoginFormTab
              setSwalProps={setSwalProps}
              setLoginTab={setLoginTab}
              setTempAuth={setTempAuth}
              credential={credential}
              showRegisterFgtPassword={showRegisterFgtPassword}
              setShowRegisterFgtPassword={setShowRegisterFgtPassword}
            />
          ) : loginTab === LoginTab.REGISTER_OPTION ? (
            <RegisterMethodTab setLoginTab={setLoginTab} />
          ) : registerTab ? (
            <RegisterTab
              setLoginTab={setLoginTab}
              setSwalProps={setSwalProps}
              loginTab={loginTab}
            />
          ) : loginTab === LoginTab.FORGOT_PASSWORD_PART_1 ||
            loginTab === LoginTab.FORGOT_PASSWORD_PART_2 ||
            loginTab === LoginTab.FORGOT_PASSWORD_PART_3 ? (
            <ForgetPasswordTab
              setLoginTab={setLoginTab}
              setSwalProps={setSwalProps}
              loginTab={loginTab}
            />
          ) : loginTab === LoginTab.LOGIN_PHONE_AUTH_STEP_1 ||
            loginTab === LoginTab.LOGIN_PHONE_AUTH_STEP_2 ? (
            <LoginPhoneAuthTab
              setLoginTab={setLoginTab}
              setSwalProps={setSwalProps}
              loginTab={loginTab}
              tempAuth={tempAuth}
            />
          ) : loginTab === LoginTab.GOOGLE_REGISTER ? (
            <GoogleRegisterTab
              setLoginTab={setLoginTab}
              setSwalProps={setSwalProps}
              loginTab={loginTab}
            />
          ) : null}
        </div>

        {(loginTab === LoginTab.LOGIN || registerTab) && (
          <div>
            <div
              className="text-warning fw-bold mt-3 mb-2 px-2"
              style={{ fontSize: "14px" }}
            >
              {intl.formatMessage({ id: "noticeUpgrade" })}
            </div>
            {showRegisterFgtPassword?.inboxists.map((inbox, idx) => (
              <div
                key={idx}
                className="bg-dark rounded m-2 p-2 shadow"
                onClick={() => handleInboxClick(inbox)}
                style={{ cursor: "pointer" }}
              >
                <div className="text-white mb-1" style={{ fontSize: "12px" }}>
                  {inbox.title}
                </div>
                {inbox.imageurl && (
                  <img
                    src={inbox.imageurl}
                    alt={inbox.title}
                    className="img-fluid rounded w-100"
                  />
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
